import { initializeAutoTracker } from '@/scripts/libs/analytic/common-autotrack';

export default (): void => {
  initializeAutoTracker();
};
